import { get } from 'lodash'
import { createSelector } from 'reselect'
import { notInRemovedAndRemovedRooms } from './events'

export const searchEvents = createSelector(
  [notInRemovedAndRemovedRooms],
  events => (term: string, maxCount = 200) => {
    const results = []
    for (let i = 0; i < events.length && results.length <= maxCount + 1; i++) {
      if (
        ['guest.name', 'guest.phone', 'guest.email', 'id', 'bookingId']
          .map(path => get(events[i], path, ''))
          .some(pathValue => {
            return pathValue
              .toString()
              .toLowerCase()
              .includes(term.toLowerCase())
          })
      ) {
        results.push(events[i])
      }
    }
    return results
  },
)
